import {
    Box,
    Flex,
    Text,
    IconButton,
    Button,
    Stack,
    Collapse,
    Icon,
    Link,
    Popover,
    PopoverTrigger,
    PopoverContent,
    useColorModeValue,
    useBreakpointValue,
    useDisclosure,
    Image,
  } from '@chakra-ui/react';
  import {
    HamburgerIcon,
    CloseIcon,
    ChevronDownIcon,
    ChevronRightIcon,
  } from '@chakra-ui/icons';
  import { Navigate, NavLink, useNavigate } from "react-router-dom"
  import Logo from "./Assets/Logo.png"
import { useSelector } from 'react-redux';
import { logout } from './firebase-config';


  export default function DashBoard() {
    const { isOpen, onToggle } = useDisclosure();
    const navigate = useNavigate();
   const auth = useSelector((store) => store.store.isAuth);
    const handlelogout = () =>{
      logout();
      // window.location.reload(false);
      auth ? navigate("/adminhome") : navigate("/")
    }
    return (
      <Box
       pos='sticky'
       z-index="1000"
       top='0'
       w="100%">
        <Flex
          bg={'white'}
          color={useColorModeValue('black', 'white')}
          minH={'60px'}
          py={{ base: 2 }}
          px={{ base: 4 }}
          borderBottom={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.900')}
          align={'center'}
          
          >
          
          <Flex
            flex={{ base: 1, md: 'auto' }}
            ml={{ base: -2 }}
            display={{ base: 'flex', md: 'none' }}>
            <IconButton
              onClick={onToggle}
              icon={
                isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
              }
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
            />
          </Flex>
          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
            <Text
              textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
              fontFamily={'heading'}
              color={useColorModeValue('gray.800', 'white')}>
               <NavLink to="/adminhome"><Image h="40px" w="40px" src={Logo} alt="monu"/></NavLink>
            </Text>
  
            <Flex display={{ base: 'none', md: 'flex' }} ml={10} >
              <DesktopNav />
            </Flex>
          </Flex>
  
          <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'row'}
            spacing={6}>
            <Button
              as={'a'}
              fontSize={'sm'}
              fontWeight={400}
              className="btn-buy"
              bg="#FFE01B"
              border="1px solid black"
              borderRadius="50px"
              onClick={handlelogout}
              >
              Log out
            </Button>
          </Stack>
        </Flex>
  
        <Collapse in={isOpen} animateOpacity>
          <MobileNav />
        </Collapse>
      </Box>
    );
  }
  
  const DesktopNav = () => {
    const linkColor = "gray.500";
    const linkHoverColor = "black";
    const popoverContentBgColor = "gray.500";
  
    return (
      <Stack direction={'row'} spacing={4}>
        {NAV_ITEMS.map((navItem) => (
          <Box key={navItem.label}>
            <Popover trigger={'hover'} placement={'bottom-start'}>
              <PopoverTrigger>
                <NavLink
                  p={2}
                  to={navItem.href ?? '#'}
                  fontSize={'sm'}
                  fontWeight={500}
                  color={linkColor}
                  _hover={{
                    textDecoration: 'none',
                    color: linkHoverColor,
                  }}>
                  {navItem.label}
                </NavLink>
              </PopoverTrigger>
  
              {navItem.children && (
                <PopoverContent
                  border={0}
                  boxShadow={'xl'}
                  bg={popoverContentBgColor}
                  p={4}
                  rounded={'xl'}
                  minW={'sm'}>
                  <Stack>
                    {navItem.children.map((child) => (
                      <DesktopSubNav key={child.label} {...child} />
                    ))}
                  </Stack>
                </PopoverContent>
              )}
            </Popover>
          </Box>
        ))}
      </Stack>
    );
  };
  
  const DesktopSubNav = ({ label, href, subLabel }) => {
    return (
      <NavLink
        to={href}
        role={'group'}
        display={'block'}
        p={2}
        rounded={'md'}
        _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
        <Stack direction={'row'} align={'center'}>
          <Box>
            <Text
              transition={'all .3s ease'}
              _groupHover={{ color: '#facc15' }}
              fontWeight={500}>
              {label}
            </Text>
            <Text fontSize={'sm'}>{subLabel}</Text>
          </Box>
          <Flex
            transition={'all .3s ease'}
            transform={'translateX(-10px)'}
            opacity={1}
            _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
            justify={'flex-end'}
            align={'center'}
            flex={1}>
            <Icon color={'#facc15'} w={5} h={5} as={ChevronRightIcon} />
          </Flex>
        </Stack>
      </NavLink>
    );
  };
  
  const MobileNav = () => {
    return (
      <Stack
        bg={useColorModeValue('white', 'gray.800')}
        p={4}
        display={{ md: 'none' }}>
        {NAV_ITEMS.map((navItem) => (
          <MobileNavItem key={navItem.label} {...navItem} />
        ))}
      </Stack>
    );
  };
  
  const MobileNavItem = ({ label, children, href }) => {
    const { isOpen, onToggle } = useDisclosure();
  
    return (
      <Stack spacing={4} onClick={children && onToggle}>
        <Flex
          py={2}
          as={Link}
          href={href ?? '#'}
          justify={'space-between'}
          align={'center'}
          _hover={{
            textDecoration: 'none',
          }}>
          <Text
            fontWeight={600}
            color={useColorModeValue('gray.600', 'gray.200')}>
            {label}
          </Text>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={'all .25s ease-in-out'}
              transform={isOpen ? 'rotate(180deg)' : ''}
              w={6}
              h={6}
            />
          )}
        </Flex>
  
        <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
          <Stack
            mt={2}
            pl={4}
            borderLeft={1}
            borderStyle={'solid'}
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            align={'start'}>
            {children &&
              children.map((child) => (
                <NavLink key={child.label} py={2} to={child.href}>
                  {child.label}
                </NavLink>
              ))}
          </Stack>
        </Collapse>
      </Stack>
    );
  };
  

  
  const NAV_ITEMS = [
    {
      label: 'Campaigns',
      children: [
        {
          label: 'All campaigns',
        //   subLabel: 'Trending Design to inspire you',
          href: '#',
        },
        {
          label: 'Email Templates',
        //   subLabel: 'Up-and-coming Designers',
          href: '#',
        },
        {
            label: 'Email analytics',
          //   subLabel: 'Up-and-coming Designers',
            href: '#',
          },
          {
            label: 'Reports',
          //   subLabel: 'Up-and-coming Designers',
            href: '#',
          },
      ],
    },
    {
      label: ' Audience',
      children: [
        {
          label: 'All contacts',
        //   subLabel: 'Find your dream design job',
          href: '#',
        },
        {
          label: 'Signup Forms',
        //   subLabel: 'An exclusive list for contract work',
          href: '#',
        },
        {
            label: 'Tags',
          //   subLabel: 'Find your dream design job',
            href: '#',
          },
          {
            label: 'Segments',
          //   subLabel: 'An exclusive list for contract work',
            href: '#',
          },
      ],
    },
    {
        label: ' Automation',
        children: [
          {
            label: 'Overveiw',
          //   subLabel: 'Find your dream design job',
            href: '#',
          },
          {
            label: 'All Journey',
          //   subLabel: 'An exclusive list for contract work',
            href: '#',
          },
          {
              label: 'Transactional Email',
            //   subLabel: 'Find your dream design job',
              href: '#',
            },
            {
              label: 'Domain',
            //   subLabel: 'An exclusive list for contract work',
              href: '#',
            },
        ],
      },
    {
        label: ' Website',
        children: [
          {
            label: 'Website',
          //   subLabel: 'Find your dream design job',
            href: '#',
          },
          {
            label: 'Store',
          //   subLabel: 'An exclusive list for contract work',
            href: '/store',
          },
          {
              label: 'Appointments',
            //   subLabel: 'Find your dream design job',
              href: '#',
            },
            {
              label: 'Domain',
            //   subLabel: 'An exclusive list for contract work',
              href: '#',
            },
        ],
      },
    {
      label: 'Content',
      href: '#',
    },
    {
      label: 'Integration',
      href: '#',
    },
  ];